import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router';
import { Header } from '@components/organisms/Header';
import { Footer } from '@components/organisms/Footer';
import { Paths } from '@src/routes/paths';
import { Page } from '@components/organisms/Page';
import { AnnouncementBar } from '@components/atoms/AnnouncementBar';
import { ImpersonationBanner } from '@src/components/ImpersonationBanner';
import { useAnnouncement } from '@hooks/useAnnouncement';

export const BaseLayout = ({
  parentPage,
  children,
  titleKey,
}: { parentPage?: Paths; titleKey: string } & PropsWithChildren) => {
  const { pathname } = useLocation();
  const { data: announcement } = useAnnouncement();
  // The dashboard announcement belongs to the home/overview page only.
  const isHome = pathname === Paths.PROFILE;

  return (
    <>
      {isHome && (
        <AnnouncementBar
          section={announcement?.dashboard}
          innerClassName="max-w-[1300px] mx-auto px-4"
        />
      )}
      <div className="h-max min-h-full flex flex-col w-full max-w-[1300px] mx-auto px-4">
        <Header parentPage={parentPage} />
        <Page titleKey={titleKey}>
          <ImpersonationBanner />
          <div className="grow">{children}</div>
        </Page>
        <Footer />
      </div>
    </>
  );
};
